const $ = jQuery;

export default {
    init() {
        const $blocks = $('.block-insights-archive');
        if (!$blocks.length) return;

        $blocks.each(function() {
            initArchiveBlock($(this));
        });
    }
};

function initArchiveBlock($container) {
    const $filters = $container.find('.filter-btn');
    const $showMoreBtn = $container.find('.show-more-btn');
    const $showLessBtn = $container.find('.show-less-btn');
    const $wrapper = $container.find('.infinite-scroll-wrapper');

    let currentCategory = $filters.filter('.active').data('filter') || 'all';
    let isFetching = false;

    $showMoreBtn.on('click', function(e) {
        e.preventDefault();
        $container.find('.extra-category').removeClass('hidden');
        $(this).addClass('hidden');
        $showLessBtn.removeClass('hidden');
    });

    $showLessBtn.on('click', function(e) {
        e.preventDefault();
        $container.find('.extra-category').addClass('hidden');
        $(this).addClass('hidden');
        $showMoreBtn.removeClass('hidden');
    });

    const fetchCategory = async (category, targetHref) => {
        if (isFetching || currentCategory === category) return;

        isFetching = true;
        currentCategory = category;

        $filters.removeClass('active bg-black text-white').addClass('bg-gray-100 text-black');
        $filters.filter(`[data-filter="${category}"]`).removeClass('bg-gray-100 text-black').addClass('active bg-black text-white');

        const url = new URL(targetHref, window.location.origin);

        const currentParams = new URLSearchParams(window.location.search);
        currentParams.delete('paged');
        currentParams.delete('category');
        url.search = currentParams.toString();

        window.history.pushState({}, '', url);

        $wrapper.addClass('opacity-50 pointer-events-none transition-opacity duration-300');

        try {
            const response = await fetch(url);
            const html = await response.text();

            await new Promise(res => setTimeout(res, 600));

            const $parsed = $($.parseHTML(html));
            const $newWrapper = $parsed.find('.infinite-scroll-wrapper');
            const $newTrigger = $parsed.find('.infinite-scroll-trigger');

            if ($newWrapper.length) {
                const $newItems = $newWrapper.find('.insight-item');
                $newItems.addClass('opacity-0 translate-y-8 transition-all duration-700 ease-out');

                $wrapper.html($newItems);
                $wrapper.removeClass('opacity-50 pointer-events-none');

                let $currentTrigger = $container.find('.infinite-scroll-trigger');
                if ($newTrigger.length) {
                    if ($currentTrigger.length) {
                        $currentTrigger.replaceWith($newTrigger);
                    } else {
                        $wrapper.after($newTrigger);
                    }
                    $(document).trigger('reinitInfiniteScroll');
                } else {
                    $currentTrigger.remove();
                }

                $('html, body').animate({
                    scrollTop: $container.find('.insights-container').offset().top - 120
                }, 400);

                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        $wrapper.find('.insight-item').each(function(i) {
                            setTimeout(() => {
                                $(this).removeClass('opacity-0 translate-y-8');
                            }, i * 150);
                        });
                    });
                });
            }
        } catch (error) {
            console.error('Filter Error:', error);
            $wrapper.removeClass('opacity-50 pointer-events-none');
        } finally {
            isFetching = false;
        }
    };

    $filters.on('click', function(e) {
        e.preventDefault();
        const $btn = $(this);
        fetchCategory($btn.data('filter'), $btn.attr('href'));
    });
}
